<template>
  <div>
    <v-navigation-drawer
        color="#222222"
        v-model="drawer"
        dark
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
    >
      <v-list v-for="item in routers" style="padding: 0!important;" :key="item.name" dense>

        <v-list-item style="padding: 0!important;"
                     v-if="item.children.length<2" @click="changeMenu(item.children[0])">
<!--          <v-list-item-icon>-->
<!--            <v-icon>{{ item.children[0].meta.icon }}</v-icon>-->
<!--          </v-list-item-icon>-->

          <v-list-item-title style="margin-left: 32px!important;">
            {{ item.children[0].meta.title }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group
            v-else
            :value="true"
            no-action
            sub-group
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
          </template>

          <v-list-item
              v-for="child in item.children"
              :key="child.name"
              link
              @click="changeMenu(child)"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.meta.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ZMenu',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'routers',
    ]),
    drawer: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  data: () => ({
    group: '',
    // items: [
    //   {name: 'UserManagement', meta: {title:'用户管理'}, path: "/user-management"},
    //   {name: 'DataPlatform', meta: {title:'iot大数据页面'}, path: "/data-platform"},
    //   {name: 'Tree', meta: {title:'业务树页面'}, path: "/layout/tree"},
    //   {name: 'CollectorManagement', meta: {title:'采集器管理页面'}, path: "/layout/collector-management"},
    //   {name: 'EqpMonitor', meta: {title:'采集器管理实时'}, path: "/layout/eqp-monitor"},
    // ],
  }),
  methods: {
    changeMenu(item) {
      this.$store.dispatch('setCurretTitle', item.meta.title);
      this.$router.push({path: item.path});
      // this.drawer = false;
    }
  },
  created() {
    console.log(this.routers, 'vuex的路由地址');
  }
}
</script>

<style scoped>

.v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > .v-list-item {
  padding-left: 30px !important;
}
</style>
